import axios from 'axios';
export default {
    requestFaqs(type, form) {
        if (type == 'put') {
            return axios.put(`${process.env.API_URL}/faqs/${form.id}`, form);
        }
        else if (type == 'post') {
            return axios.post(`${process.env.API_URL}/faqs`, form);
        } else if (type == 'delete') {
            return axios.delete(`${process.env.API_URL}/faqs/${form.id}`);
        }
        else {
            return axios.get(`${process.env.API_URL}/faqs`);
        }

    },
    getById(id) {
        return axios.get(`${process.env.API_URL}/faqs/${id}`);
    },
    requestPaginatedFaqs(limit){
        return axios.post(`${process.env.API_URL}/faqs-paginated`,{per_page:limit});
    }
}


// WEBPACK FOOTER //
// ./src/Apis/faqs.js